import React from 'react';
import MyCard from '../../Common/MyCard';
import AddSousModule from './AddSousModule';
import ListeSousModule from './ListeSousModule';

const SousModule = () => {
    return (
        <div>
            <MyCard
                titleCard="Sous module"
                addComponent={<AddSousModule />}
                content={<ListeSousModule /> }
            />
        </div>
    );
}

export default SousModule;
